import { render, staticRenderFns } from "./ChangePriceExDlg.vue?vue&type=template&id=5ff9689d&scoped=true&"
import script from "./ChangePriceExDlg.vue?vue&type=script&lang=js&"
export * from "./ChangePriceExDlg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff9689d",
  null
  
)

export default component.exports